import * as marietta3d from '../..';
import * as marietta from '../../../marietta';

/*------------------------------------------------------
* CadItem
*/
export default class AutoObjCadItem {
    public index: number;

    public guid: string;

    public flr: number;

    public p: marietta.core.Point;

    public item: string;

    public rotation: number;

    public width: number;

    public depth: number;

    public type: number;

    public idthreed: string;

    public reverse: boolean;

    public stroke: marietta3d.AutoGen.utils.RoomPointArray;

    constructor(index: number, guid: string, flr: number, p: marietta.core.Point, item: string, rot: number, wid: number, dep: number) {
      this.index = index;
      this.guid = guid;
      this.flr = flr;
      this.p = p;
      this.item = item;
      this.rotation = rot;
      this.width = wid;
      this.depth = dep;
      this.type = 0;
      this.idthreed = '';
      this.reverse = false;
      this.stroke = new marietta3d.AutoGen.utils.RoomPointArray();
      if (this.p != null) {
        const x = (this.width / 2);
        const y = (this.depth / 2);
        this.stroke.Add(new marietta.core.Point(-x, y, 0));
        this.stroke.Add(new marietta.core.Point(-x, -y, 0));
        this.stroke.Add(new marietta.core.Point(x, -y, 0));
        this.stroke.Add(new marietta.core.Point(x, y, 0));
        const zero = new marietta.core.Point(0, 0, 0);
        for (let i = 0; i < this.stroke.length; i += 1) {
          this.stroke[i].rotation(zero, this.rotation);
        }
        this.stroke.Move(this.p.x, this.p.y);
      }
    }

    /*------------------------------------------------------
    * Hit test
    *
    */
    public IsHit(mp: marietta.core.Point): boolean {
      if (this.stroke.IsInclude(mp) === marietta3d.AutoGen.utils.RC_INCLUDE.INSIDE) {
        return true;
      }
      return false;
    }

    /*------------------------------------------------------
    * Move
    *
    */
    public Move(x: number, y: number) {
      this.stroke.Move(x, y);
      this.p.x += x;
      this.p.y += y;
    }

    /*------------------------------------------------------
    * XML
    *
    */
    public createXML(cnt: number, sc: marietta3d.AutoGen.Scale): string {
      const width = (this.width / sc.WEBCAD_PITCH) * sc.module;
      const depth = (this.depth / sc.WEBCAD_PITCH) * sc.module;
      const lr = (this.reverse === true) ? '1' : '0';
      let xml = '';
      xml = `${xml}<item id="${this.item}" f="${this.flr.toString()}" index="${this.index.toString()}" guid="${this.guid}"`;
      xml = `${xml} x="${this.p.x.toString()}" y="${this.p.y.toString()}"`;
      xml = `${xml} width="${width.toString()}" depth="${depth.toString()}"`;
      xml = `${xml} rotation="${this.rotation.toString()}" lr="${lr}" idthreed="${this.idthreed}"`;
      xml += '/>\n';
      return xml;
    }

    /*------------------------------------------------------
    * XML
    *
    */
    public createXML2(doc: Document, node: Element, cnt: number, sc: marietta3d.AutoGen.Scale) {
      const width = (this.width / sc.WEBCAD_PITCH) * sc.module;
      const depth = (this.depth / sc.WEBCAD_PITCH) * sc.module;
      const lr = (this.reverse === true) ? '1' : '0';

      const nodeItem = doc.createElement('item');
      node.appendChild(nodeItem);

      nodeItem.setAttribute('id', this.item);
      nodeItem.setAttribute('f', this.flr.toString());
      nodeItem.setAttribute('index', this.index.toString());
      nodeItem.setAttribute('guid', this.guid);
      nodeItem.setAttribute('x', this.p.x.toString());
      nodeItem.setAttribute('y', this.p.y.toString());
      nodeItem.setAttribute('width', width.toString());
      nodeItem.setAttribute('depth', depth.toString());
      nodeItem.setAttribute('rotation', this.rotation.toString());
      nodeItem.setAttribute('lr', lr);
      nodeItem.setAttribute('idthreed', this.idthreed);
    }

    /*------------------------------------------------------
    * XML
    *
    */
    public readXML(item: Element, sc: marietta3d.AutoGen.Scale) {
      const rattr = item.attributes;

      this.flr = Number(rattr.getNamedItem('f').nodeValue);
      this.index = Number(rattr.getNamedItem('index').nodeValue);
      this.item = rattr.getNamedItem('id').nodeValue;

      const nodeGuid = rattr.getNamedItem('guid');
      if (nodeGuid != null) {
        this.guid = nodeGuid.nodeValue;
      } else {
        this.guid = marietta.webcad.WebCADGlobal.getGuid();
      }

      const enlr = rattr.getNamedItem('lr');
      if (enlr != null) {
        const wlr = enlr.nodeValue;
        this.reverse = (wlr === '1');
      }
      const x = Number(rattr.getNamedItem('x').nodeValue);
      const y = Number(rattr.getNamedItem('y').nodeValue);
      this.p = new marietta.core.Point(x, y, 0);

      this.rotation = Number(rattr.getNamedItem('rotation').nodeValue);

      const width = Number(rattr.getNamedItem('width').nodeValue);
      const depth = Number(rattr.getNamedItem('depth').nodeValue);

      this.width = (width / sc.module) * sc.WEBCAD_PITCH;
      this.depth = (depth / sc.module) * sc.WEBCAD_PITCH;

      const item3d = rattr.getNamedItem('idthreed');
      if (item3d != null) {
        this.idthreed = item3d.nodeValue;
      }
      if (this.idthreed === 'null') {
        this.idthreed = '';
      }

      if (this.p != null) {
        const x2 = (this.width / 2);
        const y2 = (this.depth / 2);
        this.stroke.Add(new marietta.core.Point(-x2, y2, 0));
        this.stroke.Add(new marietta.core.Point(-x2, -y2, 0));
        this.stroke.Add(new marietta.core.Point(x2, -y2, 0));
        this.stroke.Add(new marietta.core.Point(x2, y2, 0));
        const zero = new marietta.core.Point(0, 0, 0);
        for (let i = 0; i < this.stroke.length; i += 1) {
          this.stroke[i].rotation(zero, this.rotation);
        }
        this.stroke.Move(this.p.x, this.p.y);
      }
    }

    /**
     * Json
     * @param item
     * @param sc
     */
    public readJson(item: any, sc: marietta3d.AutoGen.Scale, buildingType:number = null) {
      this.flr = Number(item.f);
      this.index = Number(item.index);
      this.item = item.id;

      const nodeGuid = item.guid;
      if (nodeGuid != null) {
        this.guid = nodeGuid;
      } else {
        this.guid = marietta.webcad.WebCADGlobal.getGuid();
      }

      const enlr = item.lr;
      if (enlr != null) {
        const wlr = enlr;
        this.reverse = (wlr === '1');
      }
      let x = Number(item.x);
      let y = Number(item.y);
      if (buildingType !== null && buildingType === 1) {
        x = marietta.webcad.util.WebCADUtil.convertMMToPix(Number(item.x));
        y = marietta.webcad.util.WebCADUtil.convertMMToPix(Number(item.y));
      }
      this.p = new marietta.core.Point(x, y, 0);

      this.rotation = Number(item.rotation);

      const width = Number(item.width);
      const depth = Number(item.depth);

      this.width = (width / sc.module) * sc.WEBCAD_PITCH;
      this.depth = (depth / sc.module) * sc.WEBCAD_PITCH;

      const item3d = item.idthreed;
      if (item3d != null) {
        this.idthreed = item3d;
      }
      if (this.idthreed === 'null') {
        this.idthreed = '';
      }

      if (this.p != null) {
        const x2 = (this.width / 2);
        const y2 = (this.depth / 2);
        this.stroke.Add(new marietta.core.Point(-x2, y2, 0));
        this.stroke.Add(new marietta.core.Point(-x2, -y2, 0));
        this.stroke.Add(new marietta.core.Point(x2, -y2, 0));
        this.stroke.Add(new marietta.core.Point(x2, y2, 0));
        const zero = new marietta.core.Point(0, 0, 0);
        for (let i = 0; i < this.stroke.length; i += 1) {
          this.stroke[i].rotation(zero, this.rotation);
        }
        this.stroke.Move(this.p.x, this.p.y);
      }
    }
}
